import React from 'react';
import { PlaylistProvider } from '../../components/PlaylistContext';
import { withOrganization } from '../../components/Session';
import FindAudio from './FindAudio';

const PublicFindAudio = (props) => (
  <PlaylistProvider mode="public">
    <FindAudio {...props} mode="public" />
  </PlaylistProvider>
);

export default withOrganization(PublicFindAudio);
